'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _lodashInflection = require('lodash-inflection');
var _lodashInflection2 = _interopRequireDefault(_lodashInflection);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
_lodash2.default.mixin(_lodashInflection2.default);
var SimpleGroup = function SimpleGroup(_ref) {
  var tenants = _ref.tenants,
    selectedTenant = _ref.selectedTenant,
    resourceType = _ref.resourceType,
    label = _ref.label,
    onSelectTenant = _ref.onSelectTenant;
  return _react2.default.createElement('div', null, _react2.default.createElement('h4', null, (0, _lodash2.default)(label).pluralize(tenants.length).toString()), _react2.default.createElement('div', {
    className: 'list-group'
  }, tenants.map(function (t) {
    return /* TODO: tenant logo */(
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      _react2.default.createElement('a', {
        key: t.value,
        className: 'clickable list-group-item ' + (t.value === selectedTenant ? 'active' : ''),
        onClick: function onClick() {
          return onSelectTenant({
            value: t.value,
            label: t.label,
            resourceType: resourceType
          });
        }
      }, t.label)
    );
  })));
};
SimpleGroup.propTypes = {
  tenants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  selectedTenant: _propTypes2.default.string,
  resourceType: _propTypes2.default.string.isRequired,
  onSelectTenant: _propTypes2.default.func.isRequired,
  label: _propTypes2.default.string.isRequired
};
SimpleGroup.defaultProps = {
  selectedTenant: undefined
};
var SimpleSelect = function (_React$Component) {
  _inherits(SimpleSelect, _React$Component);
  function SimpleSelect(props) {
    _classCallCheck(this, SimpleSelect);
    var _this = _possibleConstructorReturn(this, (SimpleSelect.__proto__ || Object.getPrototypeOf(SimpleSelect)).call(this, props));
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }
  _createClass(SimpleSelect, [{
    key: 'onChange',
    value: function onChange(option) {
      var _props = this.props,
        merchants = _props.merchants,
        fulfillers = _props.fulfillers;
      var tenantGroups = {
        merchant: merchants,
        fulfiller: fulfillers
      };
      var tenantPrimaryKeys = {
        merchant: 'merchantId',
        fulfiller: 'internalFulfillerId'
      };
      var tenant = tenantGroups[option.resourceType].find(function (t) {
        return t[tenantPrimaryKeys[option.resourceType]] === option.value;
      });
      if (this.props.onChange) {
        this.props.onChange({
          type: option.resourceType,
          tenant: tenant
        });
      }
    }
  }, {
    key: 'buildMerchantOptions',
    value: function buildMerchantOptions(merchants) {
      return merchants.map(function (merchant) {
        return {
          label: merchant.displayName,
          value: merchant.merchantId
        };
      });
    }
  }, {
    key: 'buildFulfillerOptions',
    value: function buildFulfillerOptions(fulfillers) {
      return fulfillers.map(function (fulfiller) {
        return {
          label: fulfiller.name,
          value: fulfiller.internalFulfillerId
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        merchants = _props2.merchants,
        fulfillers = _props2.fulfillers,
        selectedMerchant = _props2.selectedMerchant,
        selectedFulfiller = _props2.selectedFulfiller,
        resourceType = _props2.resourceType;
      var merchantOptions = this.buildMerchantOptions(merchants);
      var fulfillerOptions = this.buildFulfillerOptions(fulfillers);
      return _react2.default.createElement('div', null, merchantOptions.length ? _react2.default.createElement(SimpleGroup, {
        tenants: merchantOptions,
        selectedTenant: resourceType === 'merchant' ? selectedMerchant : null,
        onSelectTenant: this.onChange,
        resourceType: 'merchant',
        label: 'Merchant'
      }) : null, fulfillerOptions.length ? _react2.default.createElement(SimpleGroup, {
        tenants: fulfillerOptions,
        selectedTenant: resourceType === 'fulfiller' ? selectedFulfiller : null,
        onSelectTenant: this.onChange,
        resourceType: 'fulfiller',
        label: 'Fulfiller'
      }) : null);
    }
  }]);
  return SimpleSelect;
}(_react2.default.Component);
SimpleSelect.propTypes = {
  selectedMerchant: _propTypes2.default.string,
  selectedFulfiller: _propTypes2.default.string,
  resourceType: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  merchants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    displayName: _propTypes2.default.string.isRequired,
    merchantId: _propTypes2.default.string.isRequired
  })).isRequired,
  fulfillers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    fulfillerId: _propTypes2.default.string.isRequired,
    internalFulfillerId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    archived: _propTypes2.default.bool
  })).isRequired
};
exports.default = SimpleSelect;